import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

/* HERO IMAGES */
import hero1 from "../assets/hero1.png";
import hero2 from "../assets/hero2.png";
import hero3 from "../assets/hero3.png";
const heroImages = [hero1, hero2, hero3];

const knowledgeItems = [
  { id: 1, title: "Calculators", icon: "🧮" },
  { id: 2, title: "Bulletins", icon: "📰" },
  { id: 3, title: "Utilities", icon: "🛠️" },
  { id: 4, title: "Links", icon: "🔗" },
  { id: 5, title: "Acts", icon: "⚖️" },
  { id: 6, title: "Rules", icon: "📜" },
  { id: 7, title: "Forms", icon: "📝" },
];

const homeServices = [
  {
    id: 1,
    title: "Private Limited/OPC Registration",
    desc: "Starting a Private Limited Company or a One Person Company (OPC) is the most preferred way to build a scalable business in India. A Private Limited Company offers limited liability protection to its shareholders and provides a separate legal identity. We handle everything from obtaining DSC and DIN to the final drafting of MOA and AOA, ensuring your business starts on a solid legal foundation with all necessary government registrations and PAN/TAN support."
  },
  {
    id: 2,
    title: "LLP/Partnership Firm Registration",
    desc: "A Limited Liability Partnership (LLP) offers the benefits of a company's limited liability while maintaining the flexibility of a traditional partnership. It is ideal for professional service providers and small enterprises. We provide expert consultancy in drafting customized Partnership Deeds and LLP Agreements, handling name reservation on the MCA portal, and final registration with the Registrar of Firms."
  },
  {
    id: 3,
    title: "Sole Proprietorship Firm Registration",
    desc: "Sole Proprietorship is the simplest form of business structure for individual owners. While it doesn't require complex incorporation, certain government registrations like Udyam (MSME), Shop & Establishment Act (Gumasta), and Professional Tax are mandatory to operate legally. We simplify this entire journey, ensuring you get all the legal proofs required to start your business smoothly."
  }
];

/* ANIMATION */
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const inputStyle = {
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  background: "#f8f9fb",
  outline: "none",
  fontSize: "14px"
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

export default function Home() {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(1);
  const selectedService = homeServices.find((s) => s.id === activeId);

  

  /* HERO SLIDER STATE */
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page" style={{ position: "relative" }}>
      {/* HERO SECTION - FIXED LAYOUT
        Maine isey position relative aur exact TOP margin diya hai.
        Isse yeh fixed navbar ke niche se start karega aur overrides theek ho jayenge.
      */}
      <section
        className="hero-slider"
        style={{
          height: "calc(100vh - 95px)", // Height badha di (Pehle 130px tha)
          position: "relative",
          overflow: "hidden",
          marginTop: "95px", // Navbar ki exact height ke mutabiq (Pehle 130px tha)
          top: 0
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={currentSlide}
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
            className="hero-slide active"
            style={{
              backgroundImage: `url(${heroImages[currentSlide]})`,
              position: "absolute",
              inset: 0,
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}
          ></motion.div>
        </AnimatePresence>

        {/* Premium Gradient Overlay */}
        <div style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to right, rgba(15, 43, 70, 0.9) 30%, rgba(15, 43, 70, 0.2) 100%)",
          zIndex: 1
        }}></div>

        {/* HERO CONTENT AREA */}
        <div className="hero-content" style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          margin: "0 auto",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0 20px"
        }}>
          <motion.div
            key={`text-${currentSlide}`}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span style={{
              color: "#22c55e",
              textTransform: "uppercase",
              letterSpacing: "4px",
              fontWeight: "700",
              fontSize: "14px",
              display: "block",
              marginBottom: "10px"
            }}>
              Trusted Corporate Partners
            </span>

            {/* UPDATED HEADING */}
            <h1 style={{
              fontSize: "clamp(30px, 6vw, 72px)",
              fontWeight: "900",
              lineHeight: "1.1",
              color: "#ffffff",
              marginBottom: "20px"
            }}>
              CS Manoj & <br />
              <span style={{ color: "#22c55e" }}>Associates</span> Vashi
            </h1>

            {/* UPDATED DESCRIPTION */}
            <p style={{
              fontSize: "20px",
              color: "rgba(255,255,255,0.8)",
              maxWidth: "600px",
              marginBottom: "40px",
              lineHeight: "1.6"
            }}>
              Professional Company Secretary Firm providing Corporate Compliance and Advisory Services.
            </p>

            <div style={{ display: "flex", gap: "20px" }}>
              <button
                className="hero-btn"
                onClick={() => navigate("/about")}
                style={{
                  padding: "16px 40px",
                  backgroundColor: "#22c55e",
                  border: "none",
                  borderRadius: "0",        // Sharp edges as per your requirement
                  color: "#fff",
                  fontWeight: "700",
                  fontSize: "16px",
                  cursor: "pointer",
                  marginTop: "-20px",       // Isse button upar shift hoga (value adjust kar sakte hain)
                  transition: "0.3s"
                }}
              >
                Get Started
              </button>
            </div>
          </motion.div>
        </div>

        {/* Modern Progress Pills Indicator */}
        <div style={{
          position: "absolute",
          bottom: "40px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "15px",
          zIndex: 3
        }}>
          {heroImages.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              style={{
                width: index === currentSlide ? "40px" : "12px",
                height: "6px",
                backgroundColor: index === currentSlide ? "#22c55e" : "rgba(255,255,255,0.3)",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "0.4s all ease"
              }}
            ></div>
          ))}
        </div>
      </section>

      {/* ABOUT SECTION (Now starts correctly after hero) */}
      <section className="home-about" style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "50px", alignItems: "center" }}>
          <div>
            <h2 style={{ fontSize: "42px", fontWeight: "800", marginBottom: "20px", color: "#0f2b46" }}>
              Who We <span style={{ color: "#22c55e" }}>Are</span>
              <div style={{ width: "60px", height: "4px", backgroundColor: "#22c55e", marginTop: "10px", borderRadius: "2px" }}></div>
            </h2>
            <p style={{ fontSize: "22px", lineHeight: "1.8", color: "#334155", marginBottom: "15px" }}>
              <strong style={{ color: "#0f2b46" }}>Manoj V. Ayadi & Associates</strong>, a leading firm promoted by Mr. Manoj V. Ayadi, is an integrated service law firm focused on corporate laws.
            </p>
            <p style={{ fontSize: "22px", lineHeight: "1.8", color: "#334155", marginBottom: "25px" }}>
              We provide expertise in capital market issues, public offers, acquisition of shares, and setting up of companies.
            </p>
            <button
              onClick={() => navigate("/about")}
              style={{
                padding: "14px 35px",
                border: "2px solid #22c55e",
                background: "transparent",
                color: "#22c55e",
                borderRadius: "40px",
                fontWeight: "600",
                fontSize: "16px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                transition: "0.3s"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "#22c55e";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "#22c55e";
              }}
            >
              READ MORE →
            </button>
          </div>
          <div className="about-image">
            <img src="https://www.canaveedmulla.com/images/llp_home.svg" alt="law office" style={{ width: "100%", maxWidth: "450px" }} />
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{ padding: "100px 20px", backgroundColor: "#f4f7fa" }}
      >
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
            Our Professional Services
          </h2>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
            <div style={{ width: "100px", height: "14px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
            <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
          </div>
        </div>

        <div style={{
          display: "flex",
          gap: "50px",
          maxWidth: "1200px",
          margin: "0 auto",
          alignItems: "center",
          flexWrap: "wrap"
        }}>

          <div style={{ flex: "1 1 350px", display: "flex", flexDirection: "column", gap: "15px" }}>
            {homeServices.map((service) => (
              <div
                key={service.id}
                onClick={() => setActiveId(service.id)}
                style={{
                  padding: "22px 25px",
                  cursor: "pointer",
                  borderRadius: "12px",
                  backgroundColor: activeId === service.id ? "#0f2b46" : "#ffffff",
                  color: activeId === service.id ? "#ffffff" : "#444",
                  boxShadow: activeId === service.id ? "0 10px 20px rgba(15, 43, 70, 0.2)" : "0 4px 12px rgba(0,0,0,0.05)",
                  transition: "0.3s all ease",
                  fontWeight: "700",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: activeId === service.id ? "1px solid #0f2b46" : "1px solid rgba(0,0,0,0.05)"
                }}
              >
                {service.title}
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {activeId === service.id ? "•" : "›"}
                </span>
              </div>
            ))}

            <button
              onClick={() => navigate("/services")}
              style={{
                marginTop: "10px",
                padding: "18px",
                borderRadius: "12px",
                border: "2px solid #0f2b46",
                backgroundColor: "transparent",
                color: "#0f2b46",
                fontWeight: "800",
                fontSize: "14px",
                letterSpacing: "1px",
                cursor: "pointer",
                transition: "0.3s",
                textAlign: "center",
                textTransform: "uppercase"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#0f2b46";
                e.currentTarget.style.color = "#ffffff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#0f2b46";
              }}
            >
              Others
            </button>
          </div>

          <div style={{
            flex: "2 1 650px",
            backgroundColor: "#ffffff",
            padding: "60px",
            borderRadius: "24px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.08)",
            minHeight: "450px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            border: "1px solid #f1f5f9"
          }}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeId}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ duration: 0.4 }}
              >
                <h3 style={{ color: "#0f2b46", fontSize: "32px", marginBottom: "20px", fontWeight: "850" }}>
                  {selectedService?.title}
                </h3>
                <div style={{ width: "70px", height: "6px", backgroundColor: "#22c55e", borderRadius: "10px", marginBottom: "40px" }}></div>

                <p style={{
                  color: "#475569",
                  lineHeight: "2",
                  fontSize: "19px",
                  textAlign: "justify",
                  marginBottom: "40px"
                }}>
                  {selectedService?.desc}
                </p>

                <button
                  onClick={() => navigate("/services", { state: { activeServiceId: activeId } })}
                  style={{
                    width: "fit-content",
                    padding: "15px 40px",
                    backgroundColor: "#0f2b46",
                    color: "white",
                    border: "none",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                    boxShadow: "0 10px 20px rgba(15, 43, 70, 0.15)",
                    transition: "0.3s"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
                  onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
                >
                  KNOW MORE
                </button>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </motion.section>

      {/* WHY CHOOSE US */}
      <section className="why" style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>Why Choose Us</h2>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
            <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46" }}></div>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
          </div>
        </div>
        <div className="why-container" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "30px", maxWidth: "1100px", margin: "0 auto" }}>
          {[
            { title: "Professional Expertise", desc: "Expert guidance from seasoned Company Secretaries and legal professionals.", icon: "🎓" },
            { title: "Timely Compliance", desc: "Strict adherence to deadlines ensuring your business stays 100% compliant.", icon: "⏱️" },
            { title: "Client Focused", desc: "Personalized solutions tailored specifically to your unique business needs.", icon: "🤝" }
          ].map((item, index) => (
            <motion.div key={index} whileHover={{ y: -10 }} style={{ padding: "40px 30px", backgroundColor: "#fff", borderRadius: "15px", textAlign: "center", boxShadow: "0 15px 35px rgba(26, 60, 110, 0.1)", border: "1px solid #eef2f6", position: "relative", overflow: "hidden" }}>
              <div style={{ position: "absolute", top: "-20px", right: "-20px", width: "80px", height: "80px", backgroundColor: "#f0f4f8", borderRadius: "50%", zIndex: 0 }}></div>
              <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{ fontSize: "50px", marginBottom: "20px", display: "inline-block", padding: "15px", borderRadius: "12px", backgroundColor: "#f8fafc" }}>{item.icon}</div>
                <h3 style={{ color: "#1a3c6e", fontSize: "22px", marginBottom: "15px", fontWeight: "bold" }}>{item.title}</h3>
                <p style={{ color: "#64748b", lineHeight: "1.6", fontSize: "15px" }}>{item.desc}</p>
                <div style={{ width: "50px", height: "4px", backgroundColor: "#1a3c6e", margin: "20px auto 0", borderRadius: "2px" }}></div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* WHAT OUR CUSTOMER SAYS (TESTIMONIALS) */}
      <section className="testimonials" style={{ padding: "80px 20px", backgroundColor: "#f8fafc" }}>
        {/* Heading - Exact same design as others */}
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
            What Our Customer Says
          </h2>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
            <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46" }}></div>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
          </div>
        </div>

        <div className="testimonials-grid" style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "30px",
          maxWidth: "1200px",
          margin: "0 auto"
        }}>
          {[
            {
              name: "Rajesh Mehta",
              role: "Director, TechCorp Solutions",
              feedback: "The team at CS Manoj & Associates is incredibly professional. They handled our private limited incorporation smoothly and ensured all legal compliances were met on time. Highly recommended!",
              initials: "RM"
            },
            {
              name: "Sneha Kapoor",
              role: "Founder, Bloom Fashion",
              feedback: "Best consultancy for LLP registration in Navi Mumbai. They explain every legal term so clearly that even a non-legal person can understand. Very transparent and efficient service.",
              initials: "SK"
            },
            {
              name: "Amit Verma",
              role: "Proprietor, Verma Enterprises",
              feedback: "I've been working with them for my GST and annual filings for 2 years now. Their attention to detail and timely reminders keep my business stress-free from any legal penalties.",
              initials: "AV"
            }
          ].map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -10 }}
              style={{
                padding: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "20px",
                boxShadow: "0 15px 35px rgba(15, 43, 70, 0.05)",
                border: "1px solid #f1f5f9",
                position: "relative"
              }}
            >
              {/* Quote Icon */}
              <div style={{
                fontSize: "40px",
                color: "#22c55e",
                opacity: "0.2",
                position: "absolute",
                top: "20px",
                right: "30px"
              }}>
                "
              </div>

              {/* Feedback Text */}
              <p style={{
                color: "#475569",
                fontStyle: "italic",
                lineHeight: "1.8",
                fontSize: "16px",
                marginBottom: "25px",
                position: "relative",
                zIndex: 1
              }}>
                "{item.feedback}"
              </p>

              {/* User Info Section */}
              <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <div style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#0f2b46",
                  color: "#fff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "18px"
                }}>
                  {item.initials}
                </div>
                <div>
                  <h4 style={{ margin: 0, color: "#0f2b46", fontSize: "18px", fontWeight: "700" }}>{item.name}</h4>
                  <span style={{ fontSize: "13px", color: "#64748b", fontWeight: "600" }}>{item.role}</span>
                </div>
              </div>

              {/* Rating Stars */}
              <div style={{ marginTop: "15px", color: "#fbbf24", fontSize: "14px" }}>
                ★★★★★
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* KNOWLEDGE BANK - SINGLE ROW DESIGN */}
      {/* KNOWLEDGE BANK - SINGLE ROW COMPACT DESIGN */}
     {/* KNOWLEDGE BANK - SINGLE ROW COMPACT DESIGN */}
<section className="knowledge" style={{ padding: "80px 20px", backgroundColor: "#f0f4f8" }}>
  {/* Header Section (Heading and Underline) */}
  <div style={{ textAlign: "center", marginBottom: "50px" }}>
    <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
      Knowledge Bank
    </h2>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
      <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
      <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
      <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
    </div>
  </div>

  {/* Cards Grid */}
  <div className="knowledge-grid" style={{ 
    display: "grid", 
    gridTemplateColumns: "repeat(7, 1fr)", 
    gap: "12px", 
    maxWidth: "1400px", 
    margin: "0 auto" 
  }}>
    {knowledgeItems.map((item) => (
      <motion.div 
        key={item.id} 
        whileHover={item.title === "Links" ? { scale: 1.05, y: -5 } : {}} // Sirf Links par hover effect
        onClick={() => {
          if (item.title === "Links") {
            navigate("/gst-vat-links"); // Links card par click karne par ye page open hoga
          }
        }}
        style={{ 
          backgroundColor: "#1e295b", 
          padding: "8px 8px 0px 8px", 
          borderRadius: "8px", 
          display: "flex", 
          flexDirection: "column", 
          // Sirf Links card par cursor 'pointer' dikhega
          cursor: item.title === "Links" ? "pointer" : "default", 
          boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease"
        }}
      >
        <div style={{ 
          backgroundColor: "#ffffff", 
          borderRadius: "6px 6px 0 0", 
          padding: "20px 10px", 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          justifyContent: "center", 
          position: "relative", 
          minHeight: "120px" 
        }}>
          <div style={{ 
            position: "absolute", 
            top: "8px", 
            right: "8px", 
            width: "14px", 
            height: "14px", 
            backgroundColor: "#ff9800", 
            borderRadius: "50%", 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            fontSize: "8px", 
            color: "white" 
          }}>✓</div>
          <div style={{ fontSize: "50px" }}>{item.icon}</div>
        </div>
        <div style={{ 
          color: "#ffffff", 
          padding: "12px 5px", 
          fontWeight: "600", 
          fontSize: "17px", 
          textAlign: "center" 
        }}>
          {item.title}
        </div>
      </motion.div>
    ))}
  </div>
</section>
      {/* CONTACT US */}
      <section className="contact-us" style={{ padding: "60px 20px", backgroundColor: "#ffffff", display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* CONTACT US SECTION HEADING */}
        <div style={{
          textAlign: "center",
          marginBottom: "40px",
          transform: "translateY(20px)", // Pehle 65px tha, ab upar shift kar diya hai
          zIndex: 10
        }}>
          <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
            Contact Us
          </h2>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
            <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#22c55e" }}></div>
          </div>
        </div>
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} className="contact-wrapper" style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
          <div className="contact-container" style={{
            backgroundColor: "#ffffff",
            padding: "50px",
            borderRadius: "20px",
            boxShadow: "0 20px 50px rgba(15, 43, 70, 0.08)",
            border: "1px solid #f1f5f9"
          }}>
            <div className="contact-grid">
              <motion.div variants={staggerContainer} style={{ paddingRight: "40px" }}>
                <motion.h1 variants={fadeInUp} style={{ fontSize: "34px", marginBottom: "30px", fontWeight: "800", color: "#22c55e", letterSpacing: "0.5px" }}>Get in <span style={{ color: "#22c55e" }}>Touch</span></motion.h1>
                <div className="contact-form" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                  <motion.input variants={fadeInUp} type="text" placeholder="Full Name" style={inputStyle} />
                  <motion.input variants={fadeInUp} type="email" placeholder="Email" style={inputStyle} />
                  <motion.input variants={fadeInUp} type="text" placeholder="Phone" style={inputStyle} />
                  <motion.input variants={fadeInUp} type="text" placeholder="Company" style={inputStyle} />
                  <motion.input variants={fadeInUp} type="text" placeholder="Country" style={{ ...inputStyle, gridColumn: "span 2" }} />
                  <motion.select variants={fadeInUp} style={{ ...inputStyle, gridColumn: "span 2" }}>
                    <option>Select Inquiry Type</option>
                    <option>Company Registration</option>
                    <option>GST Compliance</option>
                    <option>Trademark Support</option>
                  </motion.select>
                  <motion.textarea variants={fadeInUp} placeholder="Your Message" style={{ gridColumn: "span 2", height: "140px", padding: "15px", borderRadius: "10px", border: "1px solid #ddd", background: "#f8f9fb", outline: "none", resize: "none" }} />
                </div>
                <motion.button variants={fadeInUp} whileHover={{ scale: 1.03, backgroundColor: "#1e40af" }} whileTap={{ scale: 0.97 }} style={{ marginTop: "25px", padding: "15px 35px", background: "#2563eb", color: "white", border: "none", borderRadius: "50px", cursor: "pointer", fontWeight: "bold", fontSize: "16px", boxShadow: "0 10px 20px rgba(37, 99, 235, 0.2)" }}>Send Message</motion.button>
              </motion.div>
              <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}>
                <h1 className="contact-title" style={{ fontSize: "30px", marginBottom: "30px", fontWeight: "800", color: "#22c55e" }}>Our <span style={{ color: "#22c55e" }}>Office</span></h1>
                <div className="office-card" style={{
                  backgroundColor: "#0f2b46",
                  padding: "30px",
                  borderRadius: "15px",
                  color: "#fff",
                  boxShadow: "0 15px 30px rgba(15, 43, 70, 0.1)",
                  marginBottom: "30px"
                }}>
                  <h3 style={{ margin: "0 0 15px 0", color: "#fff", fontSize: "20px" }}>Manoj V. Ayadi & Associates</h3>
                  <div style={{ lineHeight: "1.8", opacity: "0.8", fontSize: "15px" }}>
                    <p style={{ margin: "0" }}>F-79, Haware Fantasia Business Park,</p>
                    <p style={{ margin: "0" }}>Vashi, Navi Mumbai - 400703</p>
                    <p style={{ margin: "20px 0 5px 0" }}><strong>Email:</strong> office@csmanojayadi.com</p>
                    <p style={{ margin: "0" }}><strong>Mobile:</strong> +91 9773112128</p>
                  </div>
                </div>
                <div style={{ overflow: "hidden", borderRadius: "10px" }}>
                  {/* Fixed unique title for iframe below */}
                  <iframe
                    title="Office Location Map"
                    src="https://www.google.com/maps?output=embed&q=Manoj+V+Ayadi+Associates+Haware+Fantasia+Vashi+Navi+Mumbai"
                    width="100%"
                    height="350"
                    style={{ border: 0 }}
                    loading="lazy">
                  </iframe>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
}